import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { UserData } from '../../providers/user-data';
import { CartData } from '../../providers/cart-data';
import { ProductDetailsPage } from '../../pages/orders/components/product-details';

import _ from 'lodash';

@Component({
  selector: 'page-cart',
  templateUrl: 'cart.html'
})

export class CartPage{
  public cartItems: any=[];
  public cartTotal: number=0;
  public cartCount: number=0;
  public currentUser: any;
  public isLoading: boolean = false;

  constructor(
    private nav: NavController,  
    public params: NavParams,
    private cartData: CartData,
    private userData: UserData
    ){

  }

  ionViewDidEnter() {
    this.cartItems = this.params.get("cartItems");
    this.cartItems = _.filter(this.cartItems, function(item:any){
      return (item.value.value.cartCount > 0);
    })
    this.getCartTotal();
  }

  private getCartTotal(){
    let self = this;
    self.cartTotal = 0;
    self.cartCount = 0;
    _.each(self.cartItems, function(item){
      self.cartTotal += item.value.value.cartCount * (item.value.value.onSale ? item.value.value.salePrice : item.value.value.regularPrice);
      self.cartCount += item.value.value.cartCount;
    });
  }

  //open shop-detail page
  public viewProductDetails(product) {
    this.nav.push(ProductDetailsPage, {product: product});
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/cart/cart.ts